import type { GetTrafficSourcesData, GetTrafficSourcesResponse } from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getTrafficSourcesApiModule(affiliatesApi: AxiosInstance) {
  return {
    getTrafficSources(params: GetTrafficSourcesData['query']) {
      return affiliatesApi.get<GetTrafficSourcesResponse>('/traffic-sources', { params });
    },
  }
}

